import { render, staticRenderFns } from "./TeamLead.vue?vue&type=template&id=5e515bd2&"
import script from "./TeamLead.vue?vue&type=script&lang=js&"
export * from "./TeamLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports